import { useAcceptInvitationSubmission } from './useAcceptInvitationSubmission';
import { useAcceptInvitationVerification } from './useAcceptInvitationVerification';

export function useAcceptInvitationPage() {
  const verification = useAcceptInvitationVerification();
  const submission = useAcceptInvitationSubmission({
    invitationId: verification.invitationId,
    isExistingContact: verification.isExistingContact,
    prefilledFirstName: verification.prefilledFirstName,
    prefilledLastName: verification.prefilledLastName,
    setError: verification.setError,
  });

  return {
    verificationData: verification.verificationData,
    loading: verification.loading,
    submitting: submission.submitting,
    error: verification.error,
    success: submission.success,
    formData: submission.formData,
    formErrors: submission.formErrors,
    isExistingContact: verification.isExistingContact,
    handleInputChange: submission.handleInputChange,
    handleAccept: submission.handleAccept,
    handleReject: submission.handleReject,
    goHome: submission.goHome,
    isAcceptDisabled: submission.isAcceptDisabled,
  };
}
